<template>
  <v-card
    fluid
    class="login-page-bg"
    min-height="100%"
    min-width="100%"
  >
    <template #image>
      <v-img
        :src="backgroundImg"
        cover
      />
    </template>
    <v-row>
      <v-col class="align-start mb-4">
        <img
          src="../../assets/logo/ochpower.svg"
          width="150"
          style="position: absolute; top: 25px; left: 30px;"
        >
      </v-col>
    </v-row>

    <v-row
      style="max-width: 500px"
      :class="{'align-center': $vuetify.display.xs}"
    >
      <v-col>
        <LoginForm />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import LoginForm from '../forms/LoginForm'
import backgroundImg from '../../assets/login-bg/och_power_racks.jpg'

export default {
  name: 'Login',
  components: { LoginForm },
  data: () => ({
    backgroundImg
  }),
  computed: {},
  created () {
    this.$store.dispatch('clearErrorRes')
  },
  methods: {}
}
</script>

<style>
</style>
